import dayjs from 'dayjs';

// utility to convert ISO date to "X days ago"
import relativeTime from 'dayjs/plugin/relativeTime';
import { scriptURL } from 'src/appConfig';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(relativeTime);
dayjs.extend(isSameOrAfter);

export const convertReviewRows = (rows: any[] = []) => {
  return rows.map((review) => {
    const reviewer = review.reviewer || {};
    const text = review.comment || '';
    const dateStr = review.updateTime || review.createTime;
    const date = new Date(dateStr);
    const timestamp = Math.floor(date.getTime() / 1000);
    const reviewReplyDate = review?.reviewReply?.updateTime;
    const reviewReplyComment = review?.reviewReply?.comment;

    return {
      name: reviewer?.displayName,
      image: reviewer?.profilePhotoUrl,
      stars: starRatingToNumber(review?.starRating),
      text,
      time: dayjs(date).fromNow(),
      timestamp,
      long: text.length >= 150,
      isAnonymous: reviewer?.displayName?.isAnonymous || null,
      reviewReplyDate,
      reviewReplyComment
    };
  });
};

// helper to map string star rating to number
const starRatingToNumber = (star: string): number => {
  switch (star) {
    case 'ONE':
      return 1;
    case 'TWO':
      return 2;
    case 'THREE':
      return 3;
    case 'FOUR':
      return 4;
    case 'FIVE':
      return 5;
    default:
      return 0;
  }
};

export const isWithinDateRange = (
  timestamp: number,
  filter: string
): boolean => {
  try {
    if (!timestamp || isNaN(timestamp)) {
      console.warn('isWithinDateRange: Invalid timestamp', timestamp);
      return false;
    }

    if (filter === 'All') return true;

    const now = dayjs().startOf('day');
    const reviewDate = dayjs(timestamp * 1000).startOf('day');

    if (!reviewDate.isValid()) {
      console.warn('isWithinDateRange: Invalid reviewDate', timestamp);
      return false;
    }

    switch (filter) {
      case 'Last 7 days':
        return reviewDate.isSameOrAfter(now.subtract(7, 'day'));
      case 'Last 30 days':
        return reviewDate.isSameOrAfter(now.subtract(30, 'day'));
      case 'Last 3 months':
        return reviewDate.isSameOrAfter(now.subtract(3, 'month'));
      default:
        console.warn('isWithinDateRange: Unknown filter', filter);
        return true;
    }
  } catch (err) {
    console.error('isWithinDateRange: Error while checking date range', err);
    return false;
  }
};

export const applyRule = (
  rule: { type: string; value?: string },
  text: string
) => {
  const value = rule?.value?.toLowerCase?.() || '';
  const input = text?.toLowerCase?.() || '';

  switch (rule?.type) {
    case 'is':
      return input === value;
    case 'isNot':
      return input !== value;
    case 'startsWith':
      return input.startsWith(value);
    case 'endsWith':
      return input.endsWith(value);
    case 'contains':
      return input.includes(value);
    case 'containsExact':
      return input.split(/\s+/).includes(value);
    case 'doesNotContain':
      return !input.includes(value);
    case 'isUnknown':
      return !input;
    case 'hasAnyValue':
      return !!input;
    default:
      return true;
  }
};

export const generateWidgetScriptTag = (widgetId?: string) => {


  return `<div data-widget="seospace-google-review-widget" data-widget-id="${
    widgetId || ''
  }"></div><script src="${scriptURL}static/js/widget.js"></script>`;
};
